import { useContext } from 'react';
import { useSettingsContext } from '../components/settings';

// ----------------------------------------------------------------------

const useSettings = useSettingsContext;

export default useSettings;
